import { configureStore } from '@reduxjs/toolkit'
import incomeReducer from '../features/income/incomeSlice'
export default configureStore({
  reducer: {
    reduxIncome: incomeReducer
  }
})